import toast from "react-hot-toast";
import {
  addInterestEndpoint,
  getInterestedUsersEndpoint,
  getTopRequestedRoutesEndpoint,
} from "../apiEndpoints";
import { apiConnector } from "../apiConnection";

const getToken = () => (typeof window !== "undefined" ? localStorage.getItem("token") : null);

export const addInterestApi = async (from, to, date) => {
  try {
    const bodyData = {
      from,
      to,
    };
    if (date) bodyData.date = date;

    const token = getToken();
    const request = {
      url: addInterestEndpoint.url,
      method: addInterestEndpoint.method,
      bodyData,
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    };

    toast.loading("Adding your interest...");
    await apiConnector(request);
    toast.dismiss();
    toast.success("Interest added successfully!");
  } catch (error) {
    toast.dismiss();
    toast.error("Could not add interest");
    toast.error(error?.message || "An error occurred");
    console.error(error);
  }
};

export const getTopRequestedRoutesApi = async () => {
  try {
    const token = getToken();
    const request = {
      url: getTopRequestedRoutesEndpoint.url,
      method: getTopRequestedRoutesEndpoint.method,
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    };
    const response = await apiConnector(request);
    const data = response?.data;
    if (!data) throw new Error(data?.message || "error occurred");
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getInterestedUsersApi = async (from, to) => {
  try {
    const token = getToken();
    const request = {
      url: getInterestedUsersEndpoint.url,
      method: getInterestedUsersEndpoint.method,
      params: {
        from,
        to,
      },
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    };
    const response = await apiConnector(request);
    const data = response?.data;
    if (!data) throw new Error(data?.message || "error occurred");
    return data.interest_count;
  } catch (error) {
    console.error(error);
  }
};
